export default __webpack_public_path__ + "static/media/lato-bolditalic.1600307f.eot";